<div class="w-56">
  <div (click)="eventChangeImg.emit()"
    class="outline-none cursor-pointer sm: font-semibold link text-white block text-center mx-auto p-4 rounded rounded-t-none bg-gray-400 bg-opacity-25">
    Thay đổi ảnh hồ sơ
  </div>
</div>